import { useState } from 'react'
import { Box, Button, Modal, TextField, Typography, IconButton } from '@mui/material'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useTranslation } from 'react-i18next'
import { LoadingButton } from '@mui/lab'
import ModalTitle from '../../../../../components/common/Modal/ModalTitle'
import styles from './styles.module.scss'

export const CreateSessionModal = ({ open, onClose, onSubmit, loading, sessionUrl }) => {
  const { t } = useTranslation(['common', 'messages'])
  const [metadata, setMetadata] = useState('')

  const handleSubmit = () => {
    const payload = {}

    if (metadata !== '') {
      try {
        payload.metadata = JSON.parse(metadata)
      } catch (error) {
        console.error('Invalid JSON in metadata field')
        return
      }
    }

    onSubmit(payload)
  }

  const handleCopyUrl = () => {
    if (sessionUrl) {
      navigator.clipboard.writeText(sessionUrl)
    }
  }

  const handleOpenUrl = () => {
    if (sessionUrl) {
      window.open(sessionUrl, '_blank')
    }
  }

  const handleClose = () => {
    setMetadata('')
    onClose()
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className={styles.container}>
        <ModalTitle setModalOpen={handleClose} title={t('common:createSession')} />

        {!sessionUrl ? (
          <>
            <Box className={styles.formContainer}>
              <TextField
                fullWidth
                label={t('common:metadata')}
                placeholder='{"key": "value"}'
                value={metadata}
                onChange={(e) => setMetadata(e.target.value)}
                variant="outlined"
                margin="normal"
                multiline
                rows={4}
                helperText={t('common:metadataOptional')}
              />
            </Box>
            <Box className={styles.actions}>
              <Button variant="outlined" onClick={handleClose} disabled={loading}>
                {t('common:cancel')}
              </Button>
              <LoadingButton variant="contained" onClick={handleSubmit} loading={loading}>
                {t('common:create')}
              </LoadingButton>
            </Box>
          </>
        ) : (
          <>
            <Typography variant="body1" mb={2}>
              {t('messages:sessionCreatedSuccessfully')}
            </Typography>
            <Box className={styles.urlContainer}>
              <TextField
                fullWidth
                label="Session URL"
                value={sessionUrl}
                variant="outlined"
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <Box>
                      <IconButton onClick={handleCopyUrl} title={t('common:copy')}>
                        <ContentCopyOutlinedIcon />
                      </IconButton>
                      <IconButton onClick={handleOpenUrl} title={t('common:openInNewTab')}>
                        <OpenInNewIcon />
                      </IconButton>
                    </Box>
                  ),
                }}
              />
            </Box>
            <Box className={styles.actions}>
              <Button variant="contained" onClick={handleClose}>
                {t('common:close')}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  )
}
